import * as React from "react";
const SvgFiRrSkiLift = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ski-lift_svg__a)">
      <path
        fill="#062147"
        d="M23.733 12.654a3.97 3.97 0 0 1-2.108 2.22l-19.2 9.031a1 1 0 1 1-.852-1.81l12.514-5.886-1.274-2.669-2.62 1.191a3 3 0 0 1-3.9-1.35L4.918 10a2.965 2.965 0 0 1 5.307-2.645l1.131 2.518a1 1 0 0 1-1.824.819L8.425 8.224A.94.94 0 0 0 7.88 7.8a.96.96 0 0 0-.74.068.97.97 0 0 0-.407 1.3L8.1 12.546a.99.99 0 0 0 1.262.364l2.62-1.191a2.01 2.01 0 0 1 2.632.96l1.28 2.679 4.895-2.3a2 2 0 0 0 1.034-2.649.999.999 0 1 1 1.826-.814 3.98 3.98 0 0 1 .084 3.059M2.738 15.142a7 7 0 0 0 3.71 3.317 1 1 0 1 0 .718-1.866 5 5 0 0 1-2.634-2.333L1.924 8a1 1 0 1 0-1.848.767zM14 10a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v8a1 1 0 0 0 1 1M5.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ski-lift_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkiLift;
